import React from "react";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import { categories } from "./categories"; // 🔑 importamos el slice
import "./About.css";
import { FaBalanceScale, FaFileContract, FaHome, FaMapMarkerAlt, FaMoneyBillWave } from "react-icons/fa";
import Contact from "../Contact/Contact";

const About = () => {
    return (
        <>
            <motion.section
                className="about-container"
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1 }}
            >
                <Helmet>
                    <title>Inmobiliaria Percara - Compra y Venta de Propiedades en Chajarí</title>
                    <meta
                        name="description"
                        content="Descubrí las mejores oportunidades inmobiliarias en Chajarí con Inmobiliaria Percara. Casas, terrenos, departamentos y locales comerciales a precios competitivos."
                    />
                    <meta
                        name="keywords"
                        content="inmobiliaria Chajarí, casas en venta, terrenos, departamentos, inversión inmobiliaria, propiedades en Entre Ríos, inmobiliaria confiable"
                    />
                    <meta name="author" content="Percara Inmobiliaria" />
                </Helmet>

                <motion.h1
                    className="about-title"
                    initial={{ opacity: 0, y: -30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1 }}
                    id="About"
                >
                    Bienvenido a Percara Negocios Inmobiliarios
                </motion.h1>

                <motion.h2
                    className="about-subtitle"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1.2 }}
                >
                    Especialistas en compra y venta de propiedades en Chajarí y la zona.
                </motion.h2>

                <motion.p
                    className="about-description"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1.5 }}
                >
                    En <strong>Percara Negocios Inmobiliarios</strong>, ofrecemos una amplia variedad de propiedades,
                    desde <strong>casas familiares</strong> y <strong>departamentos</strong> hasta{" "}
                    <strong>terrenos</strong> y <strong>locales comerciales</strong>. Nos destacamos por nuestra
                    atención personalizada, compromiso y discreción con cada cliente, asegurando que encontrés la
                    propiedad ideal. Si necesitás comprar, vender o tasar un inmueble, te guiaremos en cada paso del
                    proceso.
                </motion.p>

                <motion.p
                    className="about-description-1"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1.7 }}
                >
                    Si buscás <strong>comprar</strong> o <strong>vender</strong>, nuestro equipo de expertos te va a guiar
                    en cada paso del proceso. Trabajamos con total transparencia y asesoramiento profesional
                    para garantizarte una experiencia segura y eficiente.
                </motion.p>

                {/* GRID DE CATEGORÍAS */}
                <div className="container my-5">
                    <h2 className="text-center mb-4">Explorá nuestras categorías</h2>
                    <div className="row g-4">
                        {categories.map((cat) => (
                            <div key={cat.id} className="col-6 col-md-4 col-lg-3">
                                <NavLink
                                    to={cat.path}
                                    className="card text-center shadow-sm h-100 p-3 text-decoration-none category-card"
                                >
                                    <div className="fs-1 text-success mb-3">{cat.icon}</div>
                                    <h5 className="text-dark">{cat.name}</h5>
                                </NavLink>
                            </div>
                        ))}
                    </div>
                </div>

                {/* SECCIÓN DOS COLUMNAS */}
                <div className="container my-5">
                    <div className="row">
                        {/* Columna izquierda - ¿Por qué elegirnos? */}
                        <motion.div
                            className="col-12 col-md-6 about-section"
                            initial={{ opacity: 0, x: -50 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 1 }}
                        >
                            <h2 className="about-heading">¿Por qué elegirnos?</h2>
                            <ul>
                                <li><FaHome /> <strong>Amplia variedad</strong> de propiedades en Chajarí y alrededores.</li>
                                <li><FaFileContract /> <strong>Asesoramiento integral</strong> en compra y venta.</li>
                                <li><FaMoneyBillWave /> <strong>Precios competitivos</strong> y opciones de financiamiento.</li>
                                <li><FaBalanceScale /> <strong>Transparencia y seguridad</strong> en cada operación.</li>
                                <li><FaMapMarkerAlt /> <strong>Ubicaciones estratégicas</strong> para inversión y vivienda.</li>
                            </ul>
                        </motion.div>

                        {/* Columna derecha - Contacto */}
                        <motion.div
                            className="col-12 col-md-6 about-section"
                            initial={{ opacity: 0, x: 50 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 1 }}
                        >
                            <h2 className="about-heading"> ¿COMÓ CONTACTARNOS ?</h2>
                            <Contact />
                        </motion.div>
                    </div>
                </div>
            </motion.section>
        </>
    );
};

export default About;
